// extracted by mini-css-extract-plugin
module.exports = {"inner":"styles_inner__2JDDL","errorLogs":"styles_errorLogs__Nix08"};